import React from "react";
import { Transfer, Table, Form } from "antd";
import difference from "lodash/difference";
import "./style.css";

const TableTransfer = ({
  leftColumns,
  rightColumns,
  form,
  formName,
  ...restProps
}) => {
  return (
    <Form.Item name={formName}>
      <Transfer {...restProps} showSelectAll={false}>
        {({
          direction,
          filteredItems,
          onItemSelectAll,
          onItemSelect,
          selectedKeys: listSelectedKeys,
          disabled: listDisabled,
        }) => {
          const columns = direction === "left" ? leftColumns : rightColumns;

          const rowSelection = {
            getCheckboxProps: (item) => ({
              disabled: listDisabled || item.disabled,
            }),
            onSelectAll(selected, selectedRows, prevSelected) {
              const treeSelectedKeys = selectedRows
                ?.filter((item) => item?._id && !item?.disabled)
                .map(({ _id }) => _id);
              const prevSelectedKeys = prevSelected.map(({ _id }) => _id);

              const diffKeys = selected
                ? difference(treeSelectedKeys, listSelectedKeys)
                : prevSelectedKeys;
              onItemSelectAll(diffKeys, selected);
            },
            onSelect({ _id }, selected) {
              onItemSelect(_id, selected);
            },
            selectedRowKeys: listSelectedKeys,
          };

          return (
            filteredItems?.length > 0 && (
              <Table
                rowSelection={rowSelection}
                columns={columns}
                dataSource={filteredItems}
                size="small"
                rowKey="_id"
                scroll={filteredItems?.length > 10 && { y: 580 }}
                style={{ pointerEvents: listDisabled ? "none" : null }}
                onRow={({ _id, disabled: itemDisabled }) => ({
                  onClick: () => {
                    if (itemDisabled || listDisabled) return;
                    onItemSelect(_id, !listSelectedKeys.includes(_id));
                  },
                })}
              />
            )
          );
        }}
      </Transfer>
    </Form.Item>
  );
};

export default TableTransfer;
